(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veyro-english-home"] && !Shopify.designMode) return;
  try {
    
(()=>{
function init(){
const root=document.documentElement;
const motion=window.matchMedia('(prefers-reduced-motion: reduce)');
const toggle=document.querySelector('[data-motion-toggle]');
root.dataset.motion=motion.matches?'off':'on';
function setMotion(off){root.dataset.motion=off?'off':'on';if(toggle){toggle.setAttribute('aria-pressed',String(off));toggle.setAttribute('aria-label',off?toggle.dataset.resumeLabel:toggle.dataset.pauseLabel);toggle.querySelector('.motion-label').textContent=off?toggle.dataset.resumeText:toggle.dataset.pauseText;toggle.querySelector('.motion-icon').textContent=off?'▷':'Ⅱ';}}
setMotion(motion.matches);
if(toggle&&!toggle.dataset.bound){toggle.dataset.bound='true';toggle.addEventListener('click',()=>setMotion(root.dataset.motion!=='off'));}
motion.addEventListener('change',event=>setMotion(event.matches));
if('IntersectionObserver' in window){root.classList.add('motion-ready');const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-visible');observer.unobserve(entry.target);}}),{threshold:.07,rootMargin:'0px 0px -20px 0px'});document.querySelectorAll('.reveal').forEach(el=>observer.observe(el));}
const stage=document.querySelector('[data-tilt]');
if(stage&&!stage.dataset.bound){stage.dataset.bound='true';stage.addEventListener('pointermove',event=>{if(root.dataset.motion==='off'||event.pointerType==='touch')return;const box=stage.getBoundingClientRect();const x=(event.clientX-box.left)/box.width-.5;const y=(event.clientY-box.top)/box.height-.5;stage.style.setProperty('--tilt-x',`${x*10}px`);stage.style.setProperty('--tilt-y',`${y*7}px`);stage.style.setProperty('--rotate-y',`${x*5}deg`);stage.style.setProperty('--rotate-x',`${-y*4}deg`);});stage.addEventListener('pointerleave',()=>{['--tilt-x','--tilt-y','--rotate-y','--rotate-x'].forEach(key=>stage.style.removeProperty(key));});}
const image=document.getElementById('gallery-image');const status=document.getElementById('view-status');const choices=document.querySelectorAll('[data-view]');
choices.forEach(button=>{if(button.dataset.bound)return;button.dataset.bound='true';button.addEventListener('click',()=>{if(!image)return;image.src=button.dataset.src;image.alt=button.dataset.alt;image.parentElement.classList.toggle('is-kit',button.dataset.view==='1');if(status)status.textContent=button.dataset.status;choices.forEach(item=>{item.classList.toggle('selected',item===button);item.setAttribute('aria-pressed',String(item===button));});});});
if('IntersectionObserver' in window){const links=document.querySelectorAll('.site-header nav a');const navObserver=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting)links.forEach(link=>link.classList.toggle('active',link.hash==='#'+entry.target.id));}),{rootMargin:'-15% 0px -55% 0px',threshold:0});document.querySelectorAll('#system,#details,#kit').forEach(el=>navObserver.observe(el));}
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
document.addEventListener('shopify:section:load',init);
})();


  } catch(e) { console.error(e); }
})();
})();
